import { FC } from 'react';
import { Page } from 'layouts/Page';
import { PpwrRegistrationForms } from 'components/Ppwr/RegistrationForms';

export const PpwrRegistrationFormsPage: FC = () => {
	return (
		<Page title="Add New EPR/PPWR – EAS Control Center">
			<PpwrRegistrationForms />
		</Page>
	);
};
